import template from './filter-text-input.html';

class FilterTextInputComponent {
  constructor() {
    this.value = '';
  }

  valueChanged() {
    this.updateValue({
      parameterObject: {
        name: this.filterName,
        value: this.value
      }
    });
  }
}

export default {
  template,
  controller: FilterTextInputComponent,
  controllerAs: 'vm',
  bindings: {
    filterName: '@',
    updateValue: '&'
  }
};
